import axios from 'axios';

//export const API_BASE_URL = 'http://localhost:8000/api';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Добавляем токен к запросам
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Обрабатываем истекший токен
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_BASE_URL}/token/refresh/`, {
            refresh: refreshToken
          });
          
          const newAccessToken = response.data.access;
          localStorage.setItem('access_token', newAccessToken);
          
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/token/', credentials),
  register: (userData) => api.post('/register/', userData),
};

export const protectedAPI = {
  getProfile: () => api.get('/profile/'),
  getSystemState: () => api.get('/system-state/'),
  updateProfile: (data) => api.put('/profile/', data),
  getAddresses: () => api.get('/address/'),
  getAddressCount: () => api.get('/address/count'),
  createAddress: (data) => api.post('/address/', data),
  updateAdrress: (id, data) => api.put(`/address/${id}/`, data),
  deleteAddress: (id) => api.delete(`/address/${id}/`),
  getBarriers: () => api.get('/barrier/'),
  getBarrierCount: () => api.get('/barrier/count'),
  getBarrierOnlineCount: (online) => api.get(`/barrier/count?online=${online}`),
  createBarrier: (data) => api.post('/barrier/', data),
  updateBarrier: (id, data) => api.patch(`/barrier/${id}/`, data),
  deleteBarrier: (id) => api.delete(`/barrier/${id}/`),
  getCameras: () => api.get('/camera/'),
  getCameraCount: () => api.get('/camera/count'),
  getCameraOnlineCount: (is_online) => api.get(`/camera/count?is_online=${is_online}`),
  createCamera: (data) => api.post('/camera/', data),
  updateCamera: (id, data) => api.put(`/camera/${id}/`, data),
  deleteCamera: (id) => api.delete(`/camera/${id}/`),
  getCameraStream: (id) => api.get(`/cameras/${id}/start_stream/`),
  getRecognitionHistoryToday: () => api.get('/recognition-history/today'),
  getRecognitionHistoryLast: () => api.get('/recognition-history/last'),
  getPlatesByAddress: (address) => api.get(`/license-plate?address=${address}`),
  updatePlates: (id, data) => api.put(`/license-plate/${id}/`, data),
  createPlate: (data) => api.post('/license-plate/', data),
  deletePlate: (id) => api.delete(`/license-plate/${id}/`),
  getJournalByAddress: (address) => api.get(`/recognition-history?address=${address}`),
  getItems: () => api.get('/items/'),
  createItems: (data) => api.post('/items/', data),
  updateItems: (id, data) => api.put(`/items/${id}/`, data),
  deleteItems: (id) => api.delete(`/items/${id}/`),
};

export default api;